export function parseMaybeRegExp(regexp: string, flags = 'i'): RegExp {
  // string containing [] passes in the regexp constructor but throws an error in MongoDB
  const sanitizeBrackets = regexp.replace(/\[\]/g, '\\[\\]');

  try {
    return new RegExp(sanitizeBrackets, flags);
  } catch (error: unknown) {
    if (error instanceof SyntaxError) {
      return new RegExp(sanitizeBrackets.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), flags);
    }

    throw error;
  }
}
